 <template>
  <div class="cmp-b2b-home-top_release dt-page">
    <div class="top_release">
      <NTable
        :id="'b2b-home-top_release'"
        :headers="headers"
        :items="items"
        class="top_release h1"
        :config="royaltyTableConfig"
        thpad="0px"
        tdpad="0px"
        thspad="0px 10px 0px 10px"
      >
        <template v-slot:item="{ item, tdcon }">
          <tr>
            <td v-bind="tdcon('detailsb2b_artist')">
              <span :title="item['artist']">{{ item["artist"] }}</span>
            </td>
            <td v-bind="tdcon('detailsb2b_title')">
              <span :title="item['title']">{{ item["title"] }}</span>
            </td>
            <td v-bind="tdcon('detailsb2b_rank')">
              <span :title="item['top']">{{ item["top"] }}</span>
            </td>
            <td v-bind="tdcon('detailsb2b_total')">
              <span :title="item['subtotal']" style="text-align: right">{{ item["subtotal"] }} &nbsp;
                <span style="font-weight: 500">{{
                default_currency
                }}</span></span
              >
            </td>
          </tr>
        </template>
      </NTable>
    </div>
  </div>
</template>

 


<script>
import NTable from "@/plugins/datatable/datatable";
import {
  createNTableConfig,
  createTableHeader,
} from "../../../../plugins/datatable";

export default {
  components: {
    NTable,
  },
  props: {
    items: {
      type: Array,
    },
    default_currency:{
      type:String
    }
  },
  data() {
    return {
      royaltyTableConfig: createNTableConfig({
        scrollNextThreshold: 95,
      }),
    };
  },

  computed: {
    headers: function () {
      return [
        createTableHeader("detailsb2b_artist"),
        createTableHeader("detailsb2b_title"),
        createTableHeader("detailsb2b_rank", { ta: "center",mw:100 }),
        createTableHeader("detailsb2b_total", {
          ta: "right",
          mw: 120,
        }),
      ];
    },
    royalties: function () {
      return [];
    },
  },
  methods: {},
};
</script>

<style  lang="scss"  >
.cmp-b2b-home-top_release {
  height: 100%;
  overflow: hidden;
  margin: 0px 200px;
 pointer-events: none;
  @media (min-width: 320px) and (max-width: 480px) {
    margin: 0 40px;
  }
  .dt-ntable.top_release {
    height: 100%;
    overflow: hidden;
   --ntable-height: none;
    td.stmt_link,
    td.excel_link,
    td.more_icon {
      cursor: pointer;
    }
    th:nth-child(7),
    td:nth-child(7) {
      display: none;
    }
    @media (min-width: 320px) and (max-width: 480px) {
    //  --ntable-height: 250px !important;
      // td:nth-child(4),
      th:nth-child(5),
      td:nth-child(5),
      th:nth-child(6),
      td:nth-child(6) {
        display: none;
      }
      th:nth-child(7),
      td:nth-child(7) {
        display: block;
      }
    }

    th {
      color: #282828;
      font-weight: 700;
      font-family: Roboto;
      font-size: 13px;
      line-height: 18px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      border-bottom: 1px solid #c8c8c8;

      a {
        color: #0087ff;
        font-family: Roboto;
        font-size: 13px;
        line-height: 18px;
      }
    }
    td.btn_account {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    td {
      cursor: auto;
      // span {
      //   padding: 0;
      //   white-space: nowrap;
      //   overflow: hidden;
      //   text-overflow: ellipsis;
      // }
    }
    thead {
      tr {
        border-bottom: 1px solid #282828 !important;
      }
      th {
        color: #13110f !important;
      }
      &.style1 {
        --ntable-header-color: #13110f !important;
        --ntable-bb-color: #13110f !important;
      }
      &.style2 {
        --ntable-bb-color: #13110f !important;
      }
    }
  }
}
</style>

